import firebase from '@/firebase';
import { firestoreAction } from 'vuexfire';
import db from '@/db';
const state = {
  meals: [],
};

const actions = {
  init: firestoreAction(({ bindFirestoreRef }) => {
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        // bindFirestoreRef('meals', db.collection('meals').where('user_id', '==', user.uid));
        bindFirestoreRef('meals', db.collection('meals'));
      } else {
        console.log('error')
      }
    });
  }),
};

export default {
  namespaced: true,
  state,
  actions,
};